import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

import {
  BandRow,
  MetricRow,
  PreofferRouteRow,
  ReasonRow,
  SIMULATION_TIERS,
  bandRows,
  metricRows,
  movedTransitions,
  preofferReasonRows,
  preofferRouteRows,
  reasonRows,
  sampleNotes,
  unchangedCount,
} from '../../data/risk-scorecard-simulation.view'
import { BAND_UI } from '@shared/components/ciec-analysis-view/tabs/risk-scorecard.labels'
import { SimulationResult } from '../../data/risk-scorecard-config.interface'

/**
 * Resultado del simulador (plan v4.2 §10, E4): la versión activa y la candidata sobre las mismas fotos, lado a lado.
 * Solo pinta; la petición la hace el detalle de la versión. Las cuentas salen de `risk-scorecard-simulation.view.ts`.
 */
@Component({
  selector: 'app-scorecard-simulation',
  templateUrl: './scorecard-simulation.component.html',
  styleUrls: ['./scorecard-simulation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScorecardSimulationComponent {
  /** Rótulo de la candidata en las columnas: «v3» o «Sin guardar». */
  @Input() candidateLabel = 'Esta versión'
  /** Si quien mira puede abrir la ficha del cliente desde la lista de cambios. */
  @Input() canOpenClient = false

  bands: BandRow[] = []
  moved: ReturnType<typeof movedTransitions> = []
  unchanged = 0
  reasons: ReasonRow[] = []
  metrics: MetricRow[] = []
  notes: string[] = []
  preofferRoutes: PreofferRouteRow[] = []
  preofferReasons: ReturnType<typeof preofferReasonRows> = []
  result: SimulationResult | null = null

  readonly tiers = SIMULATION_TIERS
  readonly bandUi = BAND_UI

  @Input() set simulation(value: SimulationResult | null) {
    this.result = value
    this.bands = value ? bandRows(value) : []
    this.moved = value ? movedTransitions(value) : []
    this.unchanged = value ? unchangedCount(value) : 0
    this.reasons = value ? reasonRows(value) : []
    this.metrics = value ? metricRows(value) : []
    this.notes = value ? sampleNotes(value) : []
    this.preofferRoutes = value ? preofferRouteRows(value) : []
    this.preofferReasons = value ? preofferReasonRows(value) : []
  }

  //* Plan v4.3 §2b · La población de clientes nuevos con preoferta: la muestra y su vacío se dicen distinto.
  get byPreoffer(): boolean {
    return this.result?.population === 'new_clients'
  }

  get baselineLabel(): string {
    return this.result ? `Activa · v${this.result.baselineConfig.version}` : 'Activa'
  }

  /** Se simuló la propia versión activa: las dos columnas son iguales a propósito. */
  get sameVersion(): boolean {
    return !!this.result?.candidateConfig.id && this.result.candidateConfig.id === this.result.baselineConfig.id
  }

  get changedMetrics(): number {
    return this.metrics.filter((metric) => metric.changed > 0).length
  }

  trackByKey(_index: number, row: { key?: string; code?: string; band?: string; clientId?: string; leaseId?: string }): string {
    return row.key ?? row.code ?? row.band ?? row.leaseId ?? row.clientId ?? ''
  }
}
